import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LabelsState } from './labels.reducer';

export const selectLabelsState =
  createFeatureSelector<LabelsState>('labelsState');

export const getCurrentLabelsJson = createSelector(
  selectLabelsState,
  (labelState: LabelsState) => labelState
);

export const getLabelDetails = (id: any) =>
  createSelector([selectLabelsState, id], (labelState: LabelsState, id) => {
    return labelState;
  });
